export default __webpack_public_path__ + "static/media/expl-nn_05_DE.53cf5b13.png";